import React, { useState, useRef } from "react";
import "../../CSS/general.css";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Axios from "axios";
import { loginAuthProvider } from "../../LoginAuthProvider";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoaderGif from "../../images/365 loading.gif";
import FileViewer  from "./FileViewer"
const GuardianFileViewer = (props) => {
    const urlParams = new URLSearchParams(window.location.search);
    ////const [open, setOpen] = useState(true);
    const open=true;
    const [disableButton, setDisableButton] = useState(true);
    const [disableMigrateButton, setDisableMigrateButton] = useState(false);
    const [gotFileContent, setGotFileContent] = useState(false);
    const [displayLoader, setDisplayLoader] = useState(false);
    const fileContent = useRef(null);
    const [tenantId, setTenantId] = useState(null);
    const [encryptionKey, setEncryptionKey] = useState(null);
    const selectedDateRef = useRef(null);
    const selectedFileName = useRef("");
    const [selectedStateFileName, setSelectedStateFileName] = useState("");
    const [fileList, setFileList] = useState(null);
    
    const divStyle = {
        display: open ? "block" : "none",
        zIndex: "10002", width: "98%",
        margin:"1rem"

    };
    const showToast = (type, message) => {
         toast(message, {
            position: 'top-right',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: true,
        });
    }
    async function getGuardianFileList() {
        try {
            const token = await loginAuthProvider.getAccessToken();
            const tokenString = token.accessToken;
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            const response = await Axios.get(API_ROUTE + Routes.GET_GUARDIAN_FILES(orgId, tenantId, selectedDateRef.current) , config);

            if (response?.data) {
                setFileList(response.data);
            }
        } catch (error) {
            console.error('Error getGuardianFileList:', error);
        }
    }
    const downloadFile = () => {
        if (fileContent.current && fileContent.current !== "") {
            const extension = selectedFileName.current.split('.').pop();
            const mimeMap = {
                json: 'application/json',
                xml: 'application/xml',
                csv: 'text/csv',
                log: 'text/plain',
                ps1: 'text/plain',
            };

            const blob = new Blob([fileContent.current], { type: mimeMap[extension] || 'application/octet-stream' });

            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = selectedFileName.current || 'downloaded-file';
            a.click();

            URL.revokeObjectURL(url);
        }
    };
    const handleClose = () => {
        props.closeGuardianFileViewerModal();
        //setOpen(false);

    };
    const handleViewFile = () => {
        setDisplayLoader(true);
        setGotFileContent(false);
        getGuardianFileContent();
        setDisplayLoader(false)
       // props.closeGuardianFileViewerModal();
        //setOpen(false);

    };
    const handleDownloadFile = async () => {
        await getGuardianFileContent(); 
        downloadFile();                 
    };
    const handleMigrate = async () => {
        setDisableMigrateButton(true);
        await migrateGuardianFileContent();
        setDisableMigrateButton(false);
       
    };
    async function migrateGuardianFileContent() {
        try {

            const token = await loginAuthProvider.getAccessToken();
            const tokenString = token.accessToken;
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            const response = await Axios.get(API_ROUTE + Routes.MIGRATE_GUARDIAN_FILE_CONTENT(orgId,tenantId) + "?encryptionKey=" + encodeURIComponent(encryptionKey), config);

            if (response) {
                showToast("success", response.data);
            }
        } catch (error) {
            console.error('Error getGuardianFileContent:', error);
        }
    }
     async function getGuardianFileContent() {
         try {
            
            const token = await loginAuthProvider.getAccessToken();
            const tokenString = token.accessToken;
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
             let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
             const response = await Axios.get(API_ROUTE + Routes.GUARDIAN_FILE_CONTENT(orgId, selectedFileName.current, tenantId)  + "?encryptionKey=" + encodeURIComponent(encryptionKey), config);

            if (response?.data) {
                fileContent.current = response.data;
                setGotFileContent(true);
            }
        } catch (error) {
            console.error('Error getGuardianFileContent:', error);
        }
    }
    return (
        <div
            style={divStyle}
            className="modal fade show"
            id="exampleModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"

        >
            <div className="modal-content" style={{ height: "95%" }} >
                <div className="modal-header">
                    <h5>Guardian File Viewer</h5>

                    <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
                </div>
                <div className="modal-body" style={{ maxHeight: '90%', overflow: 'auto' }}>
                    <div style={{ marginBottom: '10px' }}>
                        <Form>
                            <Row className="mb-3">
                                <Col class="col">
                                    <Form.Group>
                                        <Form.Label>Tenant Id</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={tenantId}
                                            onChange={(e) => {
                                                setTenantId(e.target.value)
                                                fileContent.current = "";

                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col class="col">
                                    <Form.Group>
                                        <Form.Label>Date</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={selectedDateRef.current}
                                            onChange={(e) => {
                                                selectedDateRef.current = e.target.value;
                                                getGuardianFileList();
                                                fileContent.current = "";
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col class="col">
                                    <Form.Group>
                                        <Form.Label>File Name</Form.Label>
                                        <Form.Select
                                            value={selectedStateFileName}
                                            onChange={(e) => {
                                                selectedFileName.current = e.target.value;
                                                setSelectedStateFileName(e.target.value);
                                                if (selectedFileName.current !== "" && encryptionKey && encryptionKey !== "") { setDisableButton(false) }
                                                else { setDisableButton(true) }
                                                fileContent.current = "";
                                            }}
                                        >
                                            <option value="">Select File</option>
                                            {fileList && fileList.map((file, index) => (
                                                <option key={index} value={file}>{file}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col class="col">
                                    <Form.Group>
                                        <Form.Label>Encryption Key</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={encryptionKey}
                                            onChange={(e) => {
                                                setEncryptionKey(e.target.value);
                                                if (selectedFileName.current !== "" && e.target.value && e.target.value !== "") { setDisableButton(false) }
                                                else { setDisableButton(true) }
                                            }}
                                        />
                                    </Form.Group>

                                </Col>
                                <Col sm={1} style={{ minWidth: '13%' }}>
                                    <Form.Group style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '38px' }}>

                                        <Button variant="primary" disabled={disableButton} onClick={handleViewFile}>View</Button>&nbsp;
                                        <Button variant="primary" disabled={disableButton} onClick={handleDownloadFile}>Download</Button>
                                        &nbsp;
                                        <Button variant="primary" disabled={!(encryptionKey && encryptionKey !== "" && tenantId && tenantId!=="") || disableMigrateButton} onClick={handleMigrate}>Migrate</Button>
                                    </Form.Group>
                                </Col>
                            </Row>

                        </Form>

                    </div>

                    <div style={{
                        marginTop: '20px',
                        maxHeight: '94%',
                        height: '87%',
                        border: '1px dashed #ccc',
                        borderRadius: '8px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: '#f9f9f9'
                    }}>
                        {displayLoader.toString() === 'true' ? (
                            <img src={LoaderGif} alt="loading" style={{ height: '70px' }} />) :

                            gotFileContent && fileContent.current?.trim() && fileContent.current !== "" && fileContent.current !== "[]" ? (
                                <FileViewer fileContent={fileContent.current} />
                            ) : (
                                <span style={{ color: '#888' }}>No file selected or file has no content.</span>
                            )}
                    </div>
                </div>
            </div>
            <ToastContainer limit={4} style={{ fontSize: "small" }} /></div>

    );
}

export default GuardianFileViewer;
